<template>
  <div class="wrap">
    <el-input
      class="area"
      v-model="inputValue" 
      :autofocus="autofocus"
      :class="errorSignal ? 'error-border' : ''"
      :minlength="min"
      :maxlength="max"
      v-bind="$attrs"
      v-on="$listeners"
      :disabled="disabled"
      :placeholder="placeholder"
      @focus="inputFocus"
      @blur="inputBlur">
    </el-input>
    <p class="utin">{{utin}}</p>
    <p v-if="errorSignal" class="error-text">{{errMessage}}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      change: '',
      errorSignal: false
    }
  },

  props: {
    value: {},

    disabled: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: '请输入'
    },

    autofocus: {
      type: Boolean,
      default: false
    },

    min: {
      type: String,
      default: '0'
    },

    max: {
      type: String,
      default: '1000'
    },

    utin: {
      type: String,
      default: ''
    },

    errMessage: {
      type: String,
      default: ''
    }
  },

  computed: {
    inputValue: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  },

  watch: {
    errMessage(val) {
      if (val) {
        this.errorSignal = true
      } else {
        this.errorSignal = false
      }
    },

    inputValue(val) {
      // 这种情况说明是外部赋值致使input的值发生改变 (表单回填)
      if (val && !this.change) {
        this.change = 'blur'
      }
    }
  },

  methods: {
    inputFocus() {
      this.change = 'focus'
      this.errorSignal = false
    },

    inputBlur() {
      if (this.inputValue !== '') {
        this.change = 'blur'
      } else {
        this.change = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input {
    .el-input__inner {
        padding: 8px;
        line-height: 1;
    }
}
.wrap {
  position: relative;

  .area {
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    color: #333333;
  }

  .title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: absolute;
    left: 16px;
    top: 20px;
    margin-top: -7px;
    padding: 2px 3px;
    font-size: 14px;
    transform-origin: 0 0;
    background: #fff;
    color: #c1c4cc;
    transition: all .3s;
    pointer-events: none;
  }

  .title2 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: absolute;
    left: 16px;
    top: 20px;
    margin-top: -7px;
    padding: 2px 3px;
    font-size: 14px;
    transform-origin: 0 0;
    color: #c1c4cc;
    transition: all .3s;
    pointer-events: none;
  }

  .important {
    position: relative;
    top: 2px;
    margin-right: 2px;
    font-size: 16px;
    font-weight: bold;
    color: #E51C23;
  }

  .focus {
    font-size: 12px;
    color: #08A681;
    padding: 2px 3px;
    font-weight: bolder;
    letter-spacing: 0;
    line-height: 16px;
    transform: translate(-2px, -22px);
  }

  .blur {
    font-size: 12px;
    color: #666666;
    padding: 2px 3px;
    letter-spacing: 0;
    line-height: 16px;
    transform: translate(-2px, -22px);
  }

  .error-border {
    ::v-deep input {
      border: 1px solid #E51C23;
      line-height: 1;
    }
  }

  .error-text {
    padding: 10px 0 0 4px;
    font-size: 12px;
    color: #E51C23;
  }

  .utin {
    position: absolute;
    top: 0;
    right: 10px;
    height: 100%;
    line-height: 40px;
    font-size: 14px;
  }
}
</style>
